import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/Title";
import { Link } from "react-router-dom";

export const PrivateCloudAdvantage = () => {
  const { t } = useTranslation();
  const features = [
    {
      icon: "//files.authing.co/authing-website/icon-gradual-efficient-new.png",
      title: t("solution.privateCloud.advantage.item1.title"),
      descript: t("solution.privateCloud.advantage.item1.content"),
    },
    {
      icon: "//files.authing.co/authing-website/icon-gradual-backup-new.png",
      title: t("solution.privateCloud.advantage.item2.title"),
      descript: t("solution.privateCloud.advantage.item2.content"),
    },
    {
      icon: "//files.authing.co/authing-website/icon-gradual-security-new.png",
      title: t("solution.privateCloud.advantage.item3.title"),
      descript: t("solution.privateCloud.advantage.item3.content"),
    },
  ];
  return (
    <section className="private-cloud-advantage">
      <div className="inner">
        <h3 className="block-title">
          {t("solution.privateCloud.advantage.title")}
        </h3>
        <div className="content-warp">
          {features?.map((item) => {
            return (
              <div className="content-item">
                <div className="icon">
                  <img src={item.icon} alt="" />
                </div>
                <div className="title">{item.title}</div>
                <div className="descript">{item.descript}</div>
              </div>
            );
          })}
        </div>
        <div className="other-link">
          <div>
            <div className="description">
              {t("solution.privateCloud.advantage.customer-common")}
            </div>
            <div className="link-warp">
              <div className="logo">
                <img
                  src="//files.authing.co/authing-website/home-logo-education.png"
                  alt=""
                />
              </div>
              <Link className="link" to="/customer/hep">
                {t("solution.privateCloud.advantage.customer-link")}
                <i
                  className="icon authing-icon authing-arrow-right-line"
                  style={{ marginLeft: 6 }}
                ></i>
              </Link>
            </div>
          </div>
        </div>
        <h4 className="integrate-title">
          {t("solution.privateCloud.advantage.integrate.title")}
        </h4>
        <div className="step-warp">
          <div>
            <div className="step-item-warp">
              <div className="step-item">
                {t("solution.privateCloud.advantage.integrate.item1")}
              </div>
              <div className="step-item">
                {t("solution.privateCloud.advantage.integrate.item2")}
              </div>
            </div>
          </div>
          <div className="step-img">
            <img
              src="//files.authing.co/authing-website/private-cloud-advantage-tiny.png"
              alt="低代码实现登录认证"
            />
          </div>
        </div>
        <div className="step-item-other">
          {t("solution.privateCloud.advantage.integrate.item3")}
        </div>
      </div>
    </section>
  );
};
